var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHarddrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 8.5H1.33337",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.63337 3.90666L1.33337 8.49999V12.5C1.33337 12.8536 1.47385 13.1928 1.7239 13.4428C1.97395 13.6928 2.31309 13.8333 2.66671 13.8333H13.3334C13.687 13.8333 14.0261 13.6928 14.2762 13.4428C14.5262 13.1928 14.6667 12.8536 14.6667 12.5V8.49999L12.3667 3.90666C12.2563 3.68451 12.0862 3.49757 11.8753 3.36684C11.6645 3.23612 11.4214 3.16679 11.1734 3.16666H4.82671C4.57865 3.16679 4.33555 3.23612 4.12474 3.36684C3.91392 3.49757 3.74376 3.68451 3.63337 3.90666Z",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11.1667H4.00667",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66663 11.1667H6.67329",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHarddrive);
export default __webpack_public_path__ + "static/media/harddrive.cb55648a9176ed0bd15bf57722df2f65.svg";
export { ForwardRef as ReactComponent };